module.exports = __webpack_public_path__ + "img/Patch17-2.bcb500c5.webp";